const message = {
  success: 'Success',
  createTargetSuccess: 'Create target successfully',
  deleteTargetSuccess: 'Delete target Successfully',
  createTargetGroupSuccess: 'Create Target Group Successfully',
  deleteTargetGroupSuccess: 'Delete Target Group Successfully',
  updateTargetGroupSuccess: 'Update Target Group Successfully',
  addTargetToGroupSuccess: 'Add targets to groups successfully',
  removeTargetFromGroupSuccess: 'Remove the target from the group successfully',
  deleteScanProfileSuccessfully: 'Delete scan profile successfully',
  updateExcludedHoursProfileSuccess:
    'Update excluded hours profile successfully',
  createExcludedHoursProfileSuccess:
    'Create excluded hours profile successfully',
  createProfileSuccessfully: 'Create profile successfully',
  editProfileSuccessfully: 'Update profile successfully',
  updateUserSuccessfully: 'Update user successfully',
  createUserSuccess: 'Create user successfully',
  generateScanComparisonReportSuccess:
    'Generate scan comparison report successfully',
  deleteReportsSuccess: 'Delete reports successfully'
};

export default message;
